export function CompleteUpload(ID: number): string {
	return `/v1/attachments/${ID}/complete`;
}

export function Create(): string {
	return `/v1/attachments`;
}

export function Delete(ID: number): string {
	return `/v1/attachments/${ID}`;
}

export function Update(ID: number): string {
	return `/v1/attachments/${ID}`;
}

